export const DEFAULT_AVATAR_DARK = '/placeholders/AvatarFallbackDark.svg'
export const DEFAULT_AVATAR = '/placeholders/AvatarFallbackDark.svg'
